


















































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import ModalOptions from './modal-options.entity';

@Component
export default class ModalSuccess extends Vue {
  @Prop({
    required: true,
  })
  private value!: boolean;

  @Prop({
    required: false,
  })
  private question!: string;

  @Emit('ok')
  private ok(): void {}

  @Emit('cancel')
  private cancel(): void {}

  private get options(): ModalOptions {
    return {
      title: 'Sucesso',
      description: this.question,
      showOk: true,
      labelOk: 'Ok',
      width: 500,
    }
  }
}
